import { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { useChartContext } from '../ChartProvider'

function LineChart ({
  seriesId,
  name,
  colorBy,
  coordinateSystem,
  xAxisIndex,
  yAxisIndex,
  polarIndex,
  symbol,
  symbolSize,
  symbolRotate,
  symbolKeepAspect,
  symbolOffSet,
  showSymbol,
  showAllSymbol,
  legendHoverLink,
  stack,
  stackStrategy,
  cursor,
  connectNulls,
  clip,
  triggerLineEvent,
  step,
  label,
  endLabel,
  labelLine,
  labelLayout,
  itemStyle,
  lineStyle,
  areaStyle,
  emphasis,
  blur,
  select,
  selectedMode,
  smooth,
  smoothMonotone,
  sampling,
  dimensions,
  encode,
  seriesLayoutBy,
  datasetIndex,
  dataGroupId,
  data,
  markPoint,
  markLine,
  markArea,
  zLevel,
  z,
  silent,
  animation,
  animationThreshold,
  animationDuration,
  animationEasing,
  animationDelay,
  animationDurationUpdate,
  animationEasingUpdate,
  animationDelayUpdate,
  universalTransition,
  tooltip
}) {
  const { setSeries } = useChartContext()

  useLayoutEffect(() => {
    setSeries(seriesId, {
      type: 'line',
      id: seriesId,
      name,
      colorBy,
      coordinateSystem,
      xAxisIndex,
      yAxisIndex,
      polarIndex,
      symbol,
      symbolSize,
      symbolRotate,
      symbolKeepAspect,
      symbolOffSet,
      showSymbol,
      showAllSymbol,
      legendHoverLink,
      stack,
      stackStrategy,
      cursor,
      connectNulls,
      clip,
      triggerLineEvent,
      step,
      label,
      endLabel,
      labelLine,
      labelLayout,
      itemStyle,
      lineStyle,
      areaStyle,
      emphasis,
      blur,
      select,
      selectedMode,
      smooth,
      smoothMonotone,
      sampling,
      dimensions,
      encode,
      seriesLayoutBy,
      datasetIndex,
      dataGroupId,
      data,
      markPoint,
      markLine,
      markArea,
      zLevel,
      z,
      silent,
      animation,
      animationThreshold,
      animationDuration,
      animationEasing,
      animationDelay,
      animationDurationUpdate,
      animationEasingUpdate,
      animationDelayUpdate,
      universalTransition,
      tooltip
    })
  }, [
    setSeries,
    seriesId,
    name,
    colorBy,
    coordinateSystem,
    xAxisIndex,
    yAxisIndex,
    polarIndex,
    symbol,
    symbolSize,
    symbolRotate,
    symbolKeepAspect,
    symbolOffSet,
    showSymbol,
    showAllSymbol,
    legendHoverLink,
    stack,
    stackStrategy,
    cursor,
    connectNulls,
    clip,
    triggerLineEvent,
    step,
    label,
    endLabel,
    labelLine,
    labelLayout,
    itemStyle,
    lineStyle,
    areaStyle,
    emphasis,
    blur,
    select,
    selectedMode,
    smooth,
    smoothMonotone,
    sampling,
    dimensions,
    encode,
    seriesLayoutBy,
    datasetIndex,
    dataGroupId,
    data,
    markPoint,
    markLine,
    markArea,
    zLevel,
    z,
    silent,
    animation,
    animationThreshold,
    animationDuration,
    animationEasing,
    animationDelay,
    animationDurationUpdate,
    animationEasingUpdate,
    animationDelayUpdate,
    universalTransition,
    tooltip
  ])

  return null
}

LineChart.propTypes = {
  seriesId: PropTypes.string,
  name: PropTypes.string,
  colorBy: PropTypes.oneOf(['series', 'data']),
  coordinateSystem: PropTypes.oneOf(['cartesian2d', 'polar']),
  xAxisIndex: PropTypes.number,
  yAxisIndex: PropTypes.number,
  polarIndex: PropTypes.number,
  symbol: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  symbolSize: PropTypes.oneOfType([PropTypes.number, PropTypes.array, PropTypes.func]),
  symbolRotate: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  symbolKeepAspect: PropTypes.bool,
  symbolOffSet: PropTypes.array,
  showSymbol: PropTypes.bool,
  showAllSymbol: PropTypes.oneOf([true, false, 'auto']),
  legendHoverLink: PropTypes.bool,
  stack: PropTypes.string,
  stackStrategy: PropTypes.oneOf(['samesign', 'all', 'positive', 'negative']),
  cursor: PropTypes.string,
  connectNulls: PropTypes.bool,
  clip: PropTypes.bool,
  triggerLineEvent: PropTypes.bool,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  label: PropTypes.object,
  endLabel: PropTypes.object,
  labelLine: PropTypes.object,
  labelLayout: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  itemStyle: PropTypes.object,
  lineStyle: PropTypes.object,
  areaStyle: PropTypes.object,
  emphasis: PropTypes.object,
  blur: PropTypes.object,
  select: PropTypes.object,
  selectedMode: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  smoothMonotone: PropTypes.string,
  sampling: PropTypes.string,
  dimensions: PropTypes.array,
  encode: PropTypes.object,
  seriesLayoutBy: PropTypes.string,
  datasetIndex: PropTypes.number,
  dataGroupId: PropTypes.string,
  data: PropTypes.array,
  markPoint: PropTypes.object,
  markLine: PropTypes.object,
  markArea: PropTypes.object,
  zLevel: PropTypes.number,
  z: PropTypes.number,
  silent: PropTypes.bool,
  animation: PropTypes.bool,
  animationThreshold: PropTypes.number,
  animationDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  animationEasing: PropTypes.string,
  animationDelay: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  animationDurationUpdate: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  animationEasingUpdate: PropTypes.string,
  animationDelayUpdate: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  universalTransition: PropTypes.object,
  tooltip: PropTypes.object
}

LineChart.defaultProps = {
  coordinateSystem: 'cartesian2d'
}

export default LineChart
